import { render, staticRenderFns } from "./teacherEvaluation.vue?vue&type=template&id=89bdd1d6&scoped=true"
import script from "./teacherEvaluation.vue?vue&type=script&lang=js"
export * from "./teacherEvaluation.vue?vue&type=script&lang=js"
import style0 from "./teacherEvaluation.vue?vue&type=style&index=0&id=89bdd1d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bdd1d6",
  null
  
)

export default component.exports